<template>
  <div>
    <v-card class="tournament-card-preview" elevation="1">
      <div class="tournament-card-header header-live">
        <div class="">
          <!--          <span class="label-theme"> {{ $t('qbet') }}</span>-->
          <span
            class="label-theme"
            style="cursor: pointer"
            @click="homeHandlerAndResetState"
          >
            {{ $t('prematch') }}</span
          >

          <span
            class="context-button label-theme"
            @click="setPrintOddsMode()"
            :class="[this.getLiveMode == 'printodds' ? 'active-context' : '']"
            :title="$t('printodds')"
          >
            {{ $t('printodds') }}
          </span>
        </div>
      </div>

      <v-row justify="center" class="pt-10">
        <v-progress-linear
          indeterminate
          color="primary darken-2"
          v-if="loading"
        ></v-progress-linear>

        <v-col cols="12" md="3">
          <v-text-field
            :label="$t('event')"
            outlined
            v-model="form.qbet"
            dense
            ref="event"
            autocomplete="nope"
            type="text"
            :error-messages="errors.qbet"
            :hint="hintqbet"
            persistent-hint
            @blur="loadEventInfoAndMarketsForEvent(form.qbet)"
            v-on:keyup.enter="loadEventInfoAndMarketsForEvent(form.qbet)"
            @keydown.tab="handleTab($event)"
            tabindex="1"
            @input="form.qbet = form.qbet.trim()"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            class="sign-qbet-text-field"
            style="height: 38px !important"
            :label="$t('sign')"
            outlined
            v-model="computedSign"
            dense
            autocomplete="nope"
            type="text"
            :error-messages="errors.sign"
            persistent-hint
            tabindex="2"
            :disabled="loadingFindEvent"
            :tabindex="loadingFindEvent ? -1 : 2"
            ref="inputsign"
            @blur="findsign()"
            v-on:keyup.enter="findsign()"
          >
          </v-text-field>
          <div>
            <span
              style="padding-left: 4px; !important;"
              v-html="formattedHint"
            ></span>
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <div
            :class="['get-booked-bet-button']"
            @click="addtocart"
            v-on:keyup.enter="addtocart()"
            tabindex="3"
            ref="button-sign"
          >
            {{ $t('send') }}
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="tournament-card-header header-live">
            <div class="">
              <span class="label-theme"
                >{{ $t('group') }} {{ titleSport }}</span
              >
            </div>
            <div @click="printUserGuideHtml" style="cursor: pointer">
              <span class="action-btn" style="margin-right: 20px"
                >{{ $t('userguide') }} <v-icon dense>mdi-printer</v-icon></span
              >
              <!--              <span class="action-btn" @click="printOdds" >{{ $t('print') }} <v-icon dense>mdi-printer</v-icon></span>-->
            </div>
          </div>
        </v-col>
      </v-row>
      <v-expansion-panels tile multiple class="tree">
        <v-expansion-panel>
          <template>
            <v-expansion-panel-header class="tree-sport-level">
              <div class="path d-flex align-center" style="font-size: 13px">
                {{ $t('showMore') }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="no-padding">
              <v-expansion-panels tile class="tree-inner">
                <v-expansion-panel>
                  <div class="d-flex">
                    <v-col
                      cols="12"
                      md="12"
                      class="no-padding info-event pt-2 pb-2 pr-2 pl-2 align-self-center"
                    >
                      <div style="margin-top: 12px">
                        <v-row class="ml-0 mr-1">
                          <template v-for="n in sportMarketsComplete">
                            <v-col
                              :key="n.marketId"
                              :cols="col"
                              sm="2"
                              class="align-center m-auto pr-0 pb-0 pt-1 pl-1"
                              elevation="0"
                              outlined
                              :ref="n.marketId"
                              @click="openSubmenu2(n)"
                            >
                              <v-item
                                v-slot="{ active, toggle }"
                                class="align-center"
                              >
                                <v-card
                                  :color="
                                    selectedMarketId === n.marketId
                                      ? 'var(--first-level-odds-active)'
                                      : ''
                                  "
                                  class="d-flex align-center"
                                  dark
                                  height="50"
                                  @click="toggle"
                                  elevation="0"
                                  outlined
                                >
                                  <span
                                    class="text-sport"
                                    style="
                                      margin: auto;
                                      font-size: 12px;
                                      text-align: center;
                                    "
                                  >
                                    {{ n.text }} {{ /*n.marketId*/ }}
                                  </span>
                                </v-card>
                              </v-item>
                            </v-col>
                            <!-- Expanded outcome row -->
                            <v-col
                              v-if="selectedMarketId === n.marketId"
                              :key="'outcome_' + n.marketId"
                              cols="12"
                            >
                              <v-row class="ml-0 mr-0 scrollRow rowOutcomes">
                                <v-col
                                  v-for="o in outcomes"
                                  :key="o._attributes.id"
                                  cols="12"
                                  md="2"
                                  class="align-center m-auto pr-1 pb-1 pt-1 pl-1"
                                  elevation="0"
                                  outlined
                                  :ref="o._attributes.id"
                                  @click="fetchOutcome(o)"
                                  style="
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;
                                  "
                                >
                                  <v-item
                                    v-slot="{ active, toggle }"
                                    class="align-center"
                                  >
                                    <v-card
                                      :class="[
                                        'd-flex',
                                        'align-center',
                                        'greyQuick',
                                      ]"
                                      :color="active ? 'primary' : 'greyQuick'"
                                      dark
                                      height="50"
                                      @click="toggle"
                                      elevation="0"
                                      outlined
                                      style="
                                        flex: 1;
                                        display: flex;
                                        align-items: center;
                                      "
                                    >
                                      <span
                                        class="text-sport"
                                        style="
                                          margin: auto;
                                          font-size: 16px;
                                          text-align: center;
                                        "
                                      >
                                        <span class="sign-name">
                                          {{ o.alias }}
                                          {{
                                            getSpecifiersV2(o.unique_id)
                                          }}</span
                                        >
                                        <span class="sign-code">{{
                                          o.outcomeCode != null &&
                                          o.outcomeCode != ''
                                            ? ' - Code: ' + o.outcomeCode
                                            : ''
                                        }}</span>
                                      </span>
                                    </v-card>
                                  </v-item>
                                </v-col>
                              </v-row>
                            </v-col>
                          </template>
                        </v-row>
                      </div>
                    </v-col>
                  </div>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-content>
          </template>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isMobileOnly, isTablet } from 'mobile-device-detect'
import jsPDF from 'jspdf/dist/jspdf.es.min'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '../../plugins/device-inspector'

// import _ from 'lodash'

export default {
  name: 'QuickBetDeatil',

  data: () => ({
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    limit: 30,
    livesCount: [],
    loading: false,
    markets: [],
    sports: [],
    col: 0,
    sportMarkets: [],
    titleSport: '',
    hintqbet: '',
    errors: {
      sign: '',
      qbet: '',
    },
    size: 0,
    paginate: 0,
    outcomes: [],
    outcomesV2: [],
    sportMarketsComplete: [],
    hint: '',
    unique_id: '',
    odds: [],
    categoryPath:
      process.env.VUE_APP_URL_CLOUDFRONT + '/category-images/rectangular/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/sport-images/icons/',
    // sportPath: 'https://rocky-revenge.s3-eu-west-1.amazonaws.com/svg/sports/light/',
    sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/',
    light: window.icons == 'light' ? true : false,
    sport: '',
    event_id: null,
    previousQbet: null,
    form: {
      qbet: '',
      sign: '',
      unique_id: '',
      sport: {},
      category: {},
      tournament: {},
      odd: [],
      event: {},
      id: '',
    },
    selectedMarketId: null,
    selectedMarketName: null,
    loadingFindEvent: false,
    marketNameHint: null,
  }),

  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getTree: 'treeV2/getTree',
    }),
    computedSign: {
      get() {
        return this.form.sign
      },
      set(value) {
        if (!this.loadingFindEvent) {
          this.form.sign = value
        }
      },
    },
    formattedHint() {
      const marketName = this.marketNameHint || ''
      const sign = this.hint || ''

      return `<span class='market-name-qbet-hint'>${marketName}</span> <span class='sign-qbet-hint'>${sign}</span>`
    },
  },
  watch: {
    event_id(newValue, oldValue) {
      if (newValue != null && newValue != '' && newValue != oldValue) {
        this.form.sign = ''
        this.hint = ''
        this.odds = []
        this.outcomes = []
        this.outcomesV2 = []
      }
    },
  },
  methods: {
    handleTab(event) {
      if (this.loadingFindEvent) {
        event.preventDefault()
      }
    },

    async loadEventInfoAndMarketsForEvent(qbet) {
      if (qbet == this.previousQbet || this.form.qbet == '') {
        return
      }

      this.loading = true
      this.loadingFindEvent = true
      this.errors.qbet = this.$t('')

      const response = await this.findEventMin({
        lang: this.getLanguage,
        search: this.form.qbet,
        sport: this.sport,
      })

      if (response) {
        const event_id = response.id
        this.event_id = event_id
        this.form.event = response
        this.form.sport = response.sport
        this.sportId = response.sport.id

        this.form.category = response.category
        this.form.tournament = response.tournament

        await this.fetchMarketsByEvent(null, null, event_id)
        const competitor1 = _.find(response.competitors[0].detail, {
          lang: this.getLanguage,
        }).text
        const competitor2 = _.find(response.competitors[1].detail, {
          lang: this.getLanguage,
        }).text
        this.hintqbet = competitor1 + ' - ' + competitor2
        this.form.id = response.id
        this.loading = false
        this.loadingFindEvent = false
        this.previousQbet = qbet

        this.$nextTick(() => {
          this.$refs.inputsign.focus()
        })
      } else {
        this.errors.qbet = this.$t('errors.notfound')
        this.size = _.size(this.sportMarketsComplete)
        //this.sportMarkets = _.chunk(this.sportMarketsComplete, this.paginate)
        this.form.sign = ''
        this.form.id = ''
        this.hint = ''
        this.loading = false
        this.hintqbet = ''
        this.loadingFindEvent = false
        this.previousQbet = null
        this.form.qbet = ''

        this.$nextTick(() => {
          this.$refs.event.focus()
        })
      }
    },
    setPrintOddsMode() {
      this.setLiveMode({ mode: 'printodds' })
    },

    homeHandler() {
      this.setLiveMode({ mode: 'preview' })
      //this.selected = 'home'
    },

    homeHandlerAndResetState() {
      if (localStorage.getItem('event-detail')) {
        localStorage.removeItem('event-detail')
      }
      if (localStorage.getItem('preview-tournament-visited')) {
        localStorage.removeItem('preview-tournament-visited')
      }
      this.homeHandler()
      this.closePrematchEventsCards()
    },

    checkIsMobile() {
      return checkIsMobileDevice()
    },

    checkIsTablet() {
      return checkIsTabletDevice()
    },
    ...mapActions({
      fetchMarketSportQuickbet: 'treeV2/fetchMarketSportQuickbet',
      findEvent: 'tree/findEventQuick',
      findEventMin: 'treeV2/findEventMin',
      findEventSign: 'tree/findEventSign',
      findEventDetail: 'odds/fetchEventDetail',
      addOddToCart: 'cart/addOddToCart',
      fetchTree: 'treeV2/fetchTreeV2Complete',
      fetchOutcomesByMarket: 'treeV2/fetchOutcomesByMarket',
      fetchMarketByOutcomeCode: 'marketview/fetchMarketByOutcomeCode',
      setLiveMode: 'odds/setLiveMode',
      closePrematchEventsCards: 'odds/closePrematchEventsCards',
      fetchMarketGuideQuickbet: 'sport/fetchMarketGuideQuickbet',
    }),
    returnIcon(icon) {
      let response
      switch (icon) {
        case 'B/W':
          response = 'icons'
          break
        case 'Color':
          this.light = false
          response = 'icons_color'
          break
      }
      return response
    },

    async printUserGuide() {
      this.loading = true

      const guideResult = await this.fetchMarketGuideQuickbet()

      //todo non fare chiamate api dpulicate, non fare chiamate se sta semre lo stesso payload
      // todo mettere un loading al printing del pdf altrimenti non si capisce e alla pressione del tab non permettere di inserire il codice se l api non e anocra pronta
      // todo orindare i segni in api
      // todo ordinare gli sprad se numerici anche magari nella ui ma meglio sempre lato server
      // todo magari aggiungere un cerca market stesso nella ui per facilitare le agenzie

      const pdf = new jsPDF()
      const width = pdf.internal.pageSize.getWidth()
      pdf.text(`User guide`, width / 2, 10, { align: 'center' })

      const arrayBody = []
      _.forEach(guideResult, market => {
        arrayBody.push([
          {
            content: `${market.marketName}`,
            colSpan: 4,
            styles: {
              halign: 'center',
              fillColor: [0, 0, 0],
              textColor: [255, 255, 255],
            },
          },
        ])

        if (_.size(market.outcomes) > 0) {
          const separator = 4
          const lines = _.ceil(_.size(market.outcomes) / separator)
          const arraychunk = _.chunk(market.outcomes, separator)
          _.forEach(arraychunk, chunk => {
            const lenghtRowChunk = _.size(chunk)
            if (lenghtRowChunk > 0) {
              const elmentArray = []
              const contatoreElementi = 1
              _.forEach(chunk, el => {
                // Costruisci il testo e applica stile solo a outcomeCode
                const outcomeText =
                  el.outcomeCode != null ? ` - Code: ${el.outcomeCode}` : ''

                const cellContent = `${el.name} ${this.formatSpecifier(
                  el.specifiers
                )}${outcomeText}`

                elmentArray.push({
                  content: cellContent,
                  styles: { halign: 'center' },
                })
              })

              const difference = separator - lenghtRowChunk
              if (difference != 0) {
                for (let i = 0; i < difference; i++) {
                  elmentArray.push({
                    content: ' ',
                    styles: { halign: 'center' },
                  })
                }
              }
              arrayBody.push(elmentArray)
            }
          })
        }
      })

      pdf.autoTable({
        columnStyles: { halign: 'center', valign: 'center' },
        margin: { bottom: 20 },
        body: arrayBody,
        theme: 'grid',
        didParseCell: function (data) {
          if (data.cell.text[0].includes('Code:')) {
            data.cell.styles.fontStyle = 'bold'
          }
        },
      })

      pdf.save(`guide.pdf`)

      this.loading = false
    },
    async printUserGuideHtml() {
      this.loading = true

      try {
        const guideResultHtml = await this.fetchMarketGuideQuickbet()

        const newWindow = window.open('', '_blank')

        if (newWindow) {
          newWindow.document.write(guideResultHtml)
          newWindow.document.close()
        } else {
          console.error('It is not possible to open new window')
        }
      } catch (error) {
        console.error('Error opening user guide', error)
      } finally {
        this.loading = false
      }
    },

    cleanSportsMarkets() {
      this.sportMarkets = []
      this.sportMarketsComplete = []
    },
    async findsign() {
      this.loading = true

      if (this.isSignEmpty()) {
        this.setError('sign', 'errors.signNotActive')
        this.loading = false
        return
      }

      const market = this.findMarketBySign(this.form.sign)
      if (market) {
        await this.handleMarketFound(market)
      } else {
        await this.handleMarketNotFound()
      }

      this.loading = false
    },

    isSignEmpty() {
      return this.form.sign === ''
    },

    setError(field, messageKey) {
      this.errors[field] = this.$t(messageKey)
    },

    findMarketBySign(sign) {
      return _.find(this.sportMarketsComplete, { outcomes: [{ code: sign }] })
    },

    async handleMarketFound(market) {
      const filteredMarket = this.filterMarketOutcomes(market)
      if (!filteredMarket) {
        this.setError('sign', 'errors.notfound')
        return
      }

      // this.focusOnButtonSign();

      const response = await this.findEventSign({
        search: this.form.qbet,
        market: filteredMarket,
        code: this.form.sign,
        id: this.form.id,
      })

      if (response) {
        this.updateForm(response, filteredMarket.outcomes[0])
        await this.updateOdd(response)
      } else {
        this.handleEventNotFound()
      }
    },

    filterMarketOutcomes(market) {
      const filteredMarket = { ...market }
      filteredMarket.outcomes = _.filter(
        market.outcomes,
        el => el.code === this.form.sign
      )

      return _.size(filteredMarket.outcomes) > 0 ? filteredMarket : null
    },
    focusOnButtonSign() {
      this.$refs[`button-sign`].focus()
    },

    updateForm(response, sign) {
      this.form.event = response.event
      this.form.sport = response.sport
      this.form.category = response.category
      this.form.tournament = response.tournament
      this.hintqbet = response.event.description
      this.form.id = response.event.id
      this.errors.sign = ''

      this.form.sign = sign.code
      this.form.unique_id = sign.unique_id
    },

    async updateOdd(response) {
      if (_.size(response.event.odds) > 0) {
        await this.normalizeOddIds(response.event.odds[0].odds)
        const foundOdd = this.findOdd(response)

        if (foundOdd) {
          this.form.odd = foundOdd
          this.errors.sign = ''
          this.updateHint(foundOdd)
        } else {
          this.resetOddData()
        }
      } else {
        this.resetOddData()
      }
    },

    async normalizeOddIds(odds) {
      for await (const odd of odds) {
        if (_.startsWith(odd.unique_id, '0')) {
          odd.unique_id = odd.unique_id.substring(1)
        }
      }
    },

    findOdd(response) {
      return _.find(response.event.odds, {
        odds: [{ unique_id: `${this.form.id};${this.form.unique_id}` }],
      })
    },

    updateHint(foundOdd) {
      const spec = this.getSpecifiersV2(this.form.unique_id)
      this.marketNameHint =
        this.form.odd && this.form.odd.market_name
          ? this.form.odd.market_name
          : ' '
      this.hint =
        foundOdd.name + ' ' + spec + ' - ' + foundOdd.outcome_odd_value

      if (this.form.odd.outcome_odd_value <= 1) {
        // this.focusOnEvent();
        this.setError('sign', 'errors.signNotActive')
        this.setError('qbet', 'errors.notfound')
      }
    },

    focusOnEvent() {
      this.$refs.event.focus()
    },

    resetOddData() {
      // this.$refs[`input-sign`].focus();
      this.hint = ''
      this.form.odd = []
      this.setError('sign', 'errors.notfound')
    },

    handleEventNotFound() {
      // this.focusOnEvent();
      this.setError('sign', 'errors.notfound')
      this.setError('qbet', 'errors.notfound')
      this.event_id = null
    },

    async handleMarketNotFound() {
      const responseMarketByOutcomeCode = await this.fetchMarketByOutcomeCode({
        code: this.form.sign,
      })
      if (responseMarketByOutcomeCode) {
        await this.processMarketByOutcomeCode(responseMarketByOutcomeCode)
      } else {
        this.handleMarketNotFoundError()
      }
    },

    async processMarketByOutcomeCode(response) {
      const marketInfo = response.data

      this.selectedMarketId = marketInfo.market.id
      this.form.unique_id = this.generateUniqueId(marketInfo)

      const marketPayload = this.createMarketPayloadFromMarketInfo(marketInfo)

      const responseEvent = await this.findEventSign({
        search: this.form.qbet,
        market: marketPayload,
        code: this.form.sign,
        id: marketPayload.id,
      })

      if (responseEvent) {
        await this.updateFormWithMarketInfo(responseEvent, marketInfo)
      } else {
        this.setError('sign', 'errors.signNotActive')
      }
    },

    generateUniqueId(marketInfo) {
      return (
        marketInfo.market.id +
        (marketInfo.market.specifier ? marketInfo.market.specifier : '')
      )
    },

    async updateFormWithMarketInfo(responseEvent, marketInfo) {
      this.form.event = responseEvent.event
      /* this.form.unique_id = this.form.id + ";" + marketInfo.market.outcomes.codes[0].unique_id;*/

      this.form.unique_id =
        responseEvent.event.id + ';' + marketInfo.market.outcomes.uniqueId

      if (_.size(responseEvent.event.odds[0].odds) > 0) {
        const foundOdd = responseEvent.event.odds[0].odds.find(
          el => el.unique_id === this.form.unique_id
        )
        if (foundOdd) {
          this.form.odd = foundOdd
          this.errors.sign = ''
          this.updateHintFromOutcomeUniqueId(
            foundOdd.outcome_name,
            foundOdd.unique_id
          )
        } else {
          this.resetOddData()
        }
      } else {
        this.setError('sign', 'errors.signNotActive')
      }
    },

    handleMarketNotFoundError() {
      this.hint = ''
      this.form.odd = []
      this.setError('sign', 'errors.signNotActive')
      this.setError('qbet', 'errors.notfound')
      // this.focusOnEvent();
    },
    async addtocart() {
      if (
        this.errors != null &&
        (this.errors.qbet != '' || this.errors.sign != '')
      ) {
        return
      }
      if (!this.isSignValid()) return
      if (!this.isEventValid()) return

      this.ensureUniqueIdFormat()

      await this.addOddToCart({
        odd: this.form.odd,
        event: this.form.event,
        sport: this.form.sport,
        category: this.form.category,
        tournament: this.form.tournament,
      })

      this.emitCartUpdates()
      this.resetForm()
      this.focusOnEventInput()
      this.cleanSportsMarkets()
      this.event_id = null
    },

    isSignValid() {
      if (this.form.sign === '') {
        this.setError('sign', 'errors.sign')
        return false
      } else {
        this.clearError('sign')
        return true
      }
    },

    isEventValid() {
      if (!this.form.event.id) {
        this.setError('qbet', 'errors.qbet')
        this.cleanSportsMarkets()
        return false
      } else {
        this.clearError('qbet')
        return true
      }
    },

    setError(field, messageKey) {
      this.errors[field] = this.$t(messageKey)
    },

    clearError(field) {
      this.errors[field] = ''
    },

    ensureUniqueIdFormat() {
      const checkBet = _.split(this.form.odd.unique_id, ';')
      if (checkBet[0].length !== 10) {
        checkBet[0] = _.padStart(checkBet[0], 10, '0')
        this.form.odd.unique_id = _.join(checkBet, ';')
      }
    },

    emitCartUpdates() {
      this.$root.$emit('forceUpdateSingleMultiple')
      this.$root.$emit('forceUpdateIntegral')
      this.$root.$emit('forceUpdateSystem')
    },

    resetForm() {
      this.form.qbet = ''
      this.form.sign = ''
      this.hint = ''
      this.hintqbet = ''
      this.form.event = {}
    },

    focusOnEventInput() {
      this.$refs.event.focus()
    },
    async openSubmenu2(market) {
      this.loading = true
      this.selectedMarketId = market.marketId
      this.selectedMarketName = market.text
      this.outcomesV2 = await this.fetchOutcomesByMarket({
        sportId: this.sportId,
        event_id: this.event_id,
        marketId: market.marketId,
      })
      this.outcomes = this.outcomesV2
      this.loading = false
    },

    getSpecifiersV2(spec) {
      if (!spec) return ''

      if (spec.includes('#')) {
        const [, splitSpec, additional] = spec.split('#')
        // let result = this.formatSpecifier(splitSpec);

        // console.log('result')
        // console.log(result)

        const result = this.removeAfterSemicolon(splitSpec)

        return additional ? `${result} ${additional}` : result
      }

      return ''
    },

    formatSpecifier(splitSpec) {
      if (!splitSpec) return ''

      if (splitSpec.includes(':')) {
        return `(${splitSpec})`
      }

      if (splitSpec.includes('(') && splitSpec.includes('.')) {
        return ` [${splitSpec}] `
      }

      return splitSpec
    },

    removeAfterSemicolon(result) {
      return result.split(';')[0]
    },

    async fetchOutcome(o) {
      this.resetErrors()
      this.loading = true

      // Set form values
      this.form.sign = o.outcomeCode
      this.form.unique_id = o.unique_id
      const marketPayload = this.createMarketPayloadFromOutcome(o)

      // Fetch event sign
      const response = await this.findEventSign({
        search: this.form.qbet,
        market: marketPayload,
        code: this.form.sign,
        id: this.form.id,
      })

      // Handle response
      if (!response) {
        this.handleError('sign', 'errors.signNotActive')
        return
      }

      this.form.event = response.event
      this.processOdds(
        response.event.odds,
        o.alias,
        this.getSpecifiersV2(o.unique_id)
      )

      this.loading = false
    },

    resetErrors() {
      this.errors.sign = ''
      this.errors.qbet = ''
    },

    createMarketPayloadFromOutcome(o) {
      return {
        id: this.selectedMarketId,
        name: this.selectedMarketName,
        unique_id: this.selectedMarketId,
        sort: 1, // Consider removing or handling this sort value
        outcomes: [
          {
            id: this.selectedMarketId,
            name: o.alias,
            unique_id: o.unique_id,
            code: this.form.sign,
            autocomplete: this.form.sign,
            specifiers: this.getSpecifiersV2(o.unique_id),
          },
        ],
      }
    },
    createMarketPayloadFromMarketInfo(marketInfo) {
      return {
        id: this.selectedMarketId,
        name: this.selectedMarketName || '',
        unique_id: this.selectedMarketId,
        sort: 1,
        outcomes: [
          {
            id: this.selectedMarketId,
            name: '',
            /*unique_id: marketInfo.market.outcomes.codes[0].unique_id,*/
            unique_id: marketInfo.market.outcomes.uniqueId,
            code: this.form.sign,
            autocomplete: this.form.sign,
            specifiers: marketInfo.market.specifier || '',
          },
        ],
      }
    },

    handleError(field, errorKey) {
      this.errors[field] = this.$t(errorKey)
    },

    processOdds(odds, alias, specifiers) {
      if (odds[0] && odds[0].odds.length > 0) {
        const foundOdd = odds[0].odds.find(
          el => el.unique_id === this.form.unique_id
        )

        if (foundOdd) {
          this.form.odd = foundOdd
          this.updateHint(alias, specifiers)
          this.errors.sign = ''
        } else {
          this.resetHintAndOdds()
        }
      } else {
        this.handleError('sign', 'errors.signNotActive')
        this.form.odd = ''
      }
    },

    updateHint(alias, specifiers) {
      const spec = specifiers ? this.formatSpecifier(specifiers) : ''
      this.marketNameHint =
        this.form.odd && this.form.odd.market_name
          ? this.form.odd.market_name
          : ' '
      this.hint = `${alias} ${spec} - ${this.form.odd.outcome_odd_value}`
    },
    updateHintFromOutcomeUniqueId(alias, outcomeUniqueId) {
      const spec = outcomeUniqueId ? this.getSpecifiersV2(outcomeUniqueId) : ''
      this.marketNameHint =
        this.form.odd && this.form.odd.market_name
          ? this.form.odd.market_name
          : ' '
      this.hint = `${alias} ${spec} - ${this.form.odd.outcome_odd_value}`
    },

    resetHintAndOdds() {
      this.hint = ''
      this.form.odd = ''
      this.errors.sign = this.$t('errors.notfound')
      this.marketNameHint = ''
    },
    async fetchMarketsByEvent(sport, name, eventId) {
      this.loading = true
      this.sport = sport
      this.titleSport = name

      const filter = this.createFilter(sport, eventId)
      this.sportMarketsComplete = await this.fetchMarketSportQuickbet(filter)

      this.size = _.size(this.sportMarketsComplete)
      this.updateLayout()

      this.loading = false
    },

    createFilter(sport, event_id) {
      const filter = {
        lang: this.getLanguage,
        sportId: this.sportId,
      }

      if (event_id) {
        filter.event_id = event_id
      }

      return filter
    },

    updateLayout() {
      if (this.checkIsMobile()) {
        this.col = 12
        this.paginate = 1
      } else if (this.checkIsTablet()) {
        this.col = 6
        this.paginate = 4
      } else {
        this.col = 2
        this.paginate = 6
      }
    },

    paginateMarkets() {
      this.sportMarkets = _.chunk(this.sportMarketsComplete, this.paginate)
    },
  },
  async mounted() {
    console.log('last update quickbet 10/09/2024 time 11:30')
    this.form.qbet = ''
    this.$refs['event'].focus()
    await this.fetchTree({})
  },
}
</script>
<style>
.img-sport-light {
  filter: invert(1);
}

.img-sport-dark {
  filter: invert(0);
}
</style>
<style scoped>
/* local styles */
\deep\ .legend-box {
  display: none !important;
}

.outcome-container {
  width: 100%;
  margin-top: 10px;
}

.rowOutcomes {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 auto;
}

.greyQuick {
  flex: 1; /* Ensure the card takes full width of the column */
  display: flex;
  align-items: center;
}

.text-sport {
  font-size: 14px; /* Increase font size */
}

.sign-name {
  font-weight: bold;
}

.sign-code {
  font-size: 13px;
}
</style>
